<script setup lang="ts">
import type { AppLite } from '~/types'

interface Props {
  list: AppLite[] | undefined
}

defineProps<Props>()

const swiperInstance = ref()
const swiperAttr = reactive<Record<string, any>>({
  modules: [SwiperNavigation],
  loop: true,
  slidesPerView: 'auto',
  navigation: {
    disabledClass: 'pointer-events-none c-op-30',
    lockClass: 'hidden',
    prevEl: '.prev',
    nextEl: '.next',
  },
})

const { toAppDetail } = useRouterToPage()
</script>

<template>
  <div>
    <div v-show="list?.length" class="mx-auto w-fit flex" mb="28px md:60px">
      <Icon class="v-sub text-26px c-yellow-5 lt-md:hidden" name="Lightning" />
      <h2 class="select-none c-#ffffffe5 font-800" mx="20px md:14px" text="center 18px md:32px" lh="28px md:32px">
        {{ $t('home_page.preapp_title') }}
      </H2>
      <Icon class="v-sub text-26px c-yellow-5 lt-md:hidden" name="Lightning" />
    </div>

    <div v-if="list?.length" class="relative">
      <Swiper v-bind="swiperAttr" m="y--10px! x--20px!" p="y-10px! x-20px!" @swiper="swiperInstance = $event">
        <SwiperSlide v-for="item in list" :key="item.appId" class="w-fit!">
          <NuxtLink v-track="{ id: 'web-index-recommend-game', click: { value: { type: '即将上线', name: item.appName, seo: item.seo, pkg: item.packageName } } }" :to="toAppDetail({ seo: item.seo, type: item.category }, { hasReturnUrl: true })">
            <div
              class="group relative of-hidden transition-transform-300"
              lt-md="mie-20px pt-20px px-12px"
              md="mie-40px pt-36px px-20px hover:transform-gpu hover:translate-y--10px"
              b="~ solid transparent rd-8px" bg="clip-[padding-box,border-box] origin-[padding-box,border-box] image-[linear-gradient(#1D1B31,#1D1B31),linear-gradient(145deg,#fff3,transparent_50%)]"
            >
              <LdImage class="left-0 top-0 z-1 aspect-ratio-1 w-full op-30 blur-5px absolute!" :src="scaleImage(item.icon, 128)" alt="" loading="lazy" />

              <div class="absolute left-0 top-0 z-2 size-full bg-gradient-to-b" stops="[#1D1B311A_0_20%,#1D1B31_56%]" />

              <div
                class="absolute bottom-0 left-0 z-3 h-38% w-full translate-y-8px op-0 transition-all-300" md:group-hover="op-100 translate-y-0"
                bg="gradient-to-b" from="transparent" to="purple-5 op-30"
              />

              <div class="relative z-4 text-center">
                <div
                  class="mx-auto my--4px of-hidden rd-10px transition-colors-300"
                  size="58px md:100px" b="4px solid transparent" md:group-hover="b-purple-5"
                >
                  <LdImage class="size-full" :src="scaleImage(item.icon, 128)" alt="" loading="lazy" />
                </div>
                <p
                  class="line-clamp-2 h-36px lh-18px transition-colors-300"
                  lt-md="w-74px text-12px mb-20px mt-11px"
                  md="w-140px text-16px font-700 mb-22px mt-16px group-hover:purple-5"
                  c="#ffffffe5 "
                >
                  {{ item.appName }}
                </p>
              </div>
            </div>
          </NuxtLink>
        </SwiperSlide>

        <LdSwiperSlideButton class="prev inset-is-0 text-24px lt-md:hidden" bg="#fff op-20" c="#ffffffe5 hover:purple-5" turn="left" @click="swiperInstance?.slidePrev()" />
        <LdSwiperSlideButton class="next inset-ie-0 text-24px lt-md:hidden" bg="#fff op-20" c="#ffffffe5 hover:purple-5" turn="right" @click="swiperInstance.slideNext()" />
      </Swiper>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
